import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import PLUVA_AUTO_LOGO from '../../../../assets/svg/pluva-auto-logo.svg';
import { Button } from '../../../../components/common/buttons/Button';
import { pageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { updateManifest } from '../../../../utils/updater/updateManifest';
import { PluvaAutoBusinessPageContents } from './components/PluvaAutoBusinessPageContents';

export const PluvaAutoBusinessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    updateManifest({ manifest: { name: pageInfo.pluvaAutoBusinessPage.title } });
  }, []);

  return (
    <>
      <Helmet>
        <title>{pageInfo.pluvaAutoBusinessPage.title}</title>
      </Helmet>

      <FixedHeaderSection>
        <FixedHeaderLogoWrapper>
          <img src={PLUVA_AUTO_LOGO} alt={'pluva-auto-logo'} />
          <Button
            borderType={'square'}
            size={'sm'}
            color={'filledGreyStrong'}
            text={{ content: '사용법 보기', size: 'md' }}
            icon={{ position: 'right', size: 'Medium', fileName: 'AngleRight', fill: '#fff' }}
            onClick={() => {
              ampli.pvmClickGoToAutoCsPage();
              ReactGA.event('pvm_click_go_to_auto_CS_page');
              navigate(pageInfo.pluvaAutoCustomerServicePage.path);
            }}
          />
        </FixedHeaderLogoWrapper>
      </FixedHeaderSection>

      <Container>
        <PluvaAutoBusinessPageContents />
      </Container>

      <BlurSection />

      <FixedBottomSection>
        <MorePluvaAutoButton onClick={() => navigate(pageInfo.pluvaAutoPage.path)}>
          <MorePluvaAutoButtonText>{'플루바 오토 더 보기'}</MorePluvaAutoButtonText>
        </MorePluvaAutoButton>
      </FixedBottomSection>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;

  background-color: white;

  padding-top: 65px;
  padding-bottom: 140px;
`;

const FixedHeaderSection = styled.div`
  position: fixed;

  top: 0px;
  left: 0px;

  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 24px 0px;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
  background: var(--Light-Scheme-Monochrome-white, #fff);
  z-index: 55;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const FixedHeaderLogoWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 24px;
  justify-content: space-between;

  @media (min-width: 768px) {
    min-width: 768px;
    width: auto;
    padding: 0px 120px;
  }
`;

const FixedBottomSection = styled.div`
  position: fixed;

  width: 100%;
  max-width: 768px;

  bottom: 0px;
  left: 50%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  padding: 0px var(--radius-large, 16px) 32px var(--radius-large, 16px);
  gap: var(--radius-medium, 8px);

  transform: translate(-50%);
  background-color: white;

  z-index: 100;
`;

const MorePluvaAutoButton = styled.button`
  height: 60px;

  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  padding: var(--radius-large, 16px);
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);

  @media screen and (max-width: 768px) {
    height: 40px;
  }
`;

const MorePluvaAutoButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 17px */

  @media screen and (max-width: 768px) {
    color: var(--Light-Scheme-Monochrome-white, #fff);

    /* System/Large/l-medium */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 85%; /* 13.6px */
  }
`;

const BlurSection = styled.div`
  position: fixed;

  left: 50%;
  bottom: 92px;

  transform: translateX(-50%);

  width: 100%;
  max-width: 768px;
  height: 40px;
  padding: var(--radius-large, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 63.96%);

  @media screen and (max-width: 768px) {
    bottom: 72px;
  }
`;
